import { render, staticRenderFns } from "./activationCode.vue?vue&type=template&id=935f4dc4&scoped=true&"
import script from "./activationCode.vue?vue&type=script&lang=js&"
export * from "./activationCode.vue?vue&type=script&lang=js&"
import style0 from "./activationCode.vue?vue&type=style&index=0&id=935f4dc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935f4dc4",
  null
  
)

export default component.exports